import AceCodeEditorContainer from "../../../components/miscellaneous/editors/aceCodeEditor";

const AceCodeEditor = () => {
  return <AceCodeEditorContainer />;
};

export default AceCodeEditor;
